import React from 'react';
import SpotlightAppPreview from './SpotlightAppPreview';

// Tiles in the list come with no access details; previewing them as open
// to everyone keeps the "exclusive" label off
const OPEN_ACCESS = { group: null, level: null, tier: null };

/**
 * A spotlight group as it looks in the app: a phone screen with the group's
 * title and its tiles side by side (scrolling sideways, like the app's
 * carousel). With `ghost`, a faded empty tile follows the last one so a
 * single tile still reads as part of a row.
 */
const SpotlightPhonePreview = ({ group, tiles, ghost, emptyText }) => {
  if (!group) return null;
  // Banners and full-screen tiles take the whole width, one at a time
  const isWide = group.size === 'FULL_SCREEN' || group.format === 'BANNER';
  const showGhost = ghost && !isWide && group.format !== 'TEXT_BANNER';

  return (
    <div className="spot-preview">
      <div
        className={`spot-preview__screen${
          group.format === 'BANNER' ? ' spot-preview__screen--edge' : ''
        }`}
      >
        {/* Groups can hide their title in the app */}
        {group.title && group.titleVisible !== false && (
          <div className="spot-preview__head">{group.title}</div>
        )}
        {tiles.length > 0 ? (
          <div
            className={`spot-preview__row${
              isWide ? ' spot-preview__row--full' : ''
            }`}
          >
            {tiles.map(({ key, tile, access }) => (
              <div className="spot-preview__item" key={key}>
                <SpotlightAppPreview
                  tile={tile}
                  group={group}
                  access={access || OPEN_ACCESS}
                  descriptionAvailable={group.descriptionAvailable}
                />
              </div>
            ))}
            {showGhost && (
              <div
                className="spot-preview__item spot-preview__item--ghost"
                aria-hidden
              >
                <SpotlightAppPreview
                  tile={{}}
                  group={group}
                  access={OPEN_ACCESS}
                  descriptionAvailable={group.descriptionAvailable}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="spot-preview__empty">{emptyText}</div>
        )}
      </div>
    </div>
  );
};

export default SpotlightPhonePreview;
